<section>

  <app-modal header="Solicitação de Contacto" [isShow]="isShow" (cancel)="isShow = false"
    [style]="'lg:w-1/2'">
    <p class="text-xs mb-2">Por questões de segurança o número de contato fica oculto por padrão, caso tenha alguma
      informação utilize o campo abaixo para enviar uma solicitação de contacto.
    </p>

    @if (isLoadedOnceRetuned) {
      <div>
        @if (contactRequest) {
          <p class="mt-2 text-xs">O seu pedido encontra-se no seguinte
          estado: {{this.contactRequest.status.description}}</p>
        }
        <form [formGroup]="form" (ngSubmit)="saveContactRequest()" class="text-blueGray-700">
          <div class="my-10"><app-text-area-input [formGroup]="form" id="message" [rows]="3" [value]="form.value?.message" [maxLength]="250"
            placeholder="Olá. tenho informações sobre esta ocorrência, por favor, aceite partilhar o seu contacto comigo"
            label="Solicitação" [formError]="apiErrors.get('message')">
          </app-text-area-input></div>
        </form>
      </div>
    }


    @if (isLoadedOnceRetuned) {
      <div class="mt-6 flex justify-end">
        @if (contactRequest) {
          <app-ae-button variant="danger" label="Cancelar Pedido" icon="pi pi-times" [loading]="loading" size="sm"
          (buttonClick)="onRemoveContactRequest()"></app-ae-button>
        }
        @if (!contactRequest) {
          <app-ae-button variant="primary" (buttonClick)="saveContactRequest()" label="Submeter" icon="pi pi-save"
          [loading]="loading" size="sm"></app-ae-button>
        }
      </div>
    }
  </app-modal>
</section>
